// extracted by mini-css-extract-plugin
export default {"addsuppliermain":"AddSupplier_addsuppliermain__PD6jI","addsupplierformwrapper":"AddSupplier_addsupplierformwrapper__Rjdsl"};